<template>
  <v-card
    style="overflow: hidden; border: 2px solid"
    :style="`border-color: ${$vuetify.theme.themes.light.primary}`"
  >
    <v-row>
      <v-col align="center">
        <h2>
          {{ $translate('CROP_EXPL') }}
        </h2>
        <p>{{ overlayText }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="7" align="center">
        <v-row>
          <v-col>
            <vue-cropper
              class="cropper-area"
              v-if="imgSrc"
              ref="cropper"
              :aspect-ratio="aspectRatio"
              :autoCropArea="1"
              :src="imgSrc"
              preview=".preview"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="primary"
                  role="button"
                  @click.prevent="resetCropper"
                >
                  <v-icon> mdi-restore </v-icon>
                </v-btn>
              </template>
              <span>{{ $translate('EVENT_RESET') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="primary"
                  role="button"
                  @click.prevent="flipX"
                >
                  <v-icon> mdi-swap-horizontal </v-icon>
                </v-btn>
              </template>
              <span>{{ $translate('FLIP_X') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="primary"
                  role="button"
                  @click.prevent="flipY"
                >
                  <v-icon> mdi-swap-vertical </v-icon>
                </v-btn>
              </template>
              <span>{{ $translate('FLIP_Y') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="5" align="center">
        <v-row>
          <v-col align="center">
            <h2>{{ $translate('PREVIEW') }}</h2>
            <div class="preview" />
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center" cols="10" offset="1">
            <v-text-field
              v-if="file && multiple"
              :maxlength="maxNameLength"
              v-model="filename"
              :placeholder="$translate('IMAGE') + ' ' + $translate('NAME')"
              class="ma-0 pa-0"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center" cols="10" offset="1">
            <v-btn
              class="primary"
              role="button"
              @click.prevent="cropImage"
              block
            >
              {{ $translate('SAVE_IMAGE') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import VueCropper from 'vue-cropperjs';

export default {
  name: 'ImageCropper',
  components: {
    VueCropper,
  },
  props: {
    file: File,
    multiple: Boolean,
    aspectRatio: Number,
    overlayText: {
      Type: String,
      Default: '',
    },
  },
  data() {
    return {
      maxNameLength: 128,
      scaleY: 1,
      scaleX: 1,
      filename: '',
      cropImg: '',
      imgSrc: '',
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    file() {
      this.filename = '';
      this.cropImg = '';
      this.imgSrc = '';
      this.init();
    },
  },
  methods: {
    init() {
      if (this.file) {
        this.filename = this.file.name;
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result);
          };
          reader.readAsDataURL(this.file);
        } else {
          alert('Sorry, FileReader API not supported');
        }
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL(`${this.file.type}`);
      this.$emit('imageCropped', this.cropImg, this.filename);
    },
    resetCropper() {
      this.$refs.cropper.reset();
    },
    flipX() {
      this.scaleX = -this.scaleX;
      this.$refs.cropper.scaleX(this.scaleX);
    },
    flipY() {
      this.scaleY = -this.scaleY;
      this.$refs.cropper.scaleY(this.scaleY);
    },
  },
};
</script>

<style scope>
.wrapper {
  height: 350px;
  overflow: auto;
  width: 100%;
  overflow-y: hidden;
}
.cropper-area {
  max-width: 614px;
  max-height: calc(614px * (3 / 4));
}
.preview {
  width: 100%;
  height: calc(372px * (3 / 4));
  overflow: hidden;
}
</style>
